import {
  DownOutlined,
  ExportOutlined,
  LoadingOutlined,
  UploadOutlined
} from "@ant-design/icons"
import { Dropdown } from "antd"
import React, { useRef, useState } from "react"

import { showErrorNotifications } from "../utils/handlers/handle-error"

interface LeadsImportProps {
  onImport: (file: File) => Promise<void>
  onDownloadTemplate: () => Promise<void>
}

export function ImportButton({
  onImport,
  onDownloadTemplate
}: LeadsImportProps) {
  const [loading, setLoading] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const onMainClick = () => {
    inputRef.current?.click()
  }

  const onSyncFncClick = async (fnc: () => Promise<void>) => {
    setLoading(true)
    try {
      await fnc()
    } finally {
      setLoading(false)
    }
  }

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const isXlsx =
      file.name.endsWith(".xlsx") ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

    if (!isXlsx) {
      showErrorNotifications("Only .xlsx files are allowed")
      e.target.value = ""
      return
    }

    void onSyncFncClick(() => onImport(file))
    e.target.value = ""
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        style={{ display: "none" }}
        onChange={onFileChange}
      />
      <Dropdown.Button
        type="primary"
        disabled={loading}
        icon={<DownOutlined />}
        onClick={onMainClick}
        className={"w-fit"}
        menu={{
          items: [
            {
              key: "download_template",
              icon: <UploadOutlined />,
              label: "Download Template",
              onClick: () => onSyncFncClick(onDownloadTemplate)
            }
          ]
        }}
      >
        {loading ? <LoadingOutlined /> : <ExportOutlined />} Import
      </Dropdown.Button>
    </>
  )
}
